import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const LoginAuditListDetails = () => { 
  const [loginAuditLogs, setLoginAuditLogs] = useState([]); 
  
  useEffect(() => { 
    fetchLoginAuditLogs(); 
  }, []); 
  
  const fetchLoginAuditLogs = async () => { 
    try { 
      const url = `${API_DOMAIN}${API_ROUTES.login_activity}`; 
      const token = localStorage.getItem('token'); 
       
      const response = await axios.get(url, { headers }); 
      const loginAuditLogsData = response.data.map((log) => {
        return { 
          ...log, 
          status_name: log.status === "SUCCESS" ? "Success" : 
                      log.status === "FAILED" ? "Failed" : "", 
        };
      });
      setLoginAuditLogs(loginAuditLogsData); 
    } catch (error) { 
      console.error('Error fetching login audit logs:', error); 
    } 
  };
  
  const columns = [ 
    { label: 'Status', value: 'status_name' }, 
    { label: 'User', value: 'user' }, 
    { label: 'IP Address', value: 'ip_address' }, 
    { label: 'User Agent', value: 'user_agent' }, 
    { label: 'Timestamp', value: 'timestamp' }, 
  ]; 
  
  const handleViewDetails = (logId) => { 
    //console.log('View Details', logId); 
    const encodedId = btoa(logId); 
    window.location.href = `/login/activity/details/${encodedId}`; 
  }; 
  
  const handleEditDetails = (logId) => {
    const encodedId = btoa(logId); 
    window.location.href = `/login/activity/input/${encodedId}`;
  };
  
  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 
  
  return <ListTemplate columns={columns} data={loginAuditLogs} actionButtons={actionButtons} />; 
}; 
  
export default LoginAuditListDetails;